import React from 'react'

import { Link, TOAST_VARIANT_ERROR, toastShow } from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

import getIntl from 'Helpers/intl'

export const notifyDisconnected = (): void => {
  const intl = getIntl()

  const handleReconnect = (): void => {
    notifyParent('redirectMainFrame', [
      `settings_app_redirector.aspx?r=${encodeURIComponent(
        '/settings/integrations/connectors/fatture-in-cloud-connector',
      )}`,
    ])
  }

  toastShow(
    <div>
      {intl.formatMessage(
        { id: 'Load.ImportFattureInCloud.DisconnectedError' },
        {
          link: (chunks: string) => (
            <Link data-mu-test="fic-disconnected" onClick={handleReconnect}>
              {chunks}
            </Link>
          ),
        },
      )}
    </div>,
    TOAST_VARIANT_ERROR,
  )
}
